import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { clientPortalRequest } from "../../api/clientPortalFetch";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";

const ClientResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const paths = useClientPortalPaths();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setErrorMessage("Password reset token is missing.");
      setLoading(false);
      return;
    }
    fetch(`/api/client/auth/password-reset/validate?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then((body) => {
        if (!body.success) {
          throw new Error(body.message || "Invalid reset link.");
        }
        setEmail(body.email || "");
      })
      .catch((e) => setErrorMessage(e.message || "Invalid password reset link."))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirm) {
      setErrorMessage("Passwords do not match.");
      return;
    }
    setErrorMessage("");
    try {
      await clientPortalRequest("/auth/password-reset/complete", {
        method: "POST",
        body: JSON.stringify({ token, password }),
      });
      setSuccess(true);
      setTimeout(() => navigate(paths.login, { replace: true }), 2000);
    } catch (e) {
      setErrorMessage(e.message || "Could not reset password.");
    }
  };

  if (loading) {
    return (
      <div className="midpoint-app auth-page">
        <p className="panel-card muted">Validating reset link…</p>
      </div>
    );
  }

  return (
    <div className="midpoint-app auth-page">
      <section className="panel-card auth-card">
        <h1>Reset password</h1>
        {success ? (
          <p className="muted">Password updated. Redirecting to login…</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="muted">Set a new password for {email}</p>
            {errorMessage ? <p className="auth-error">{errorMessage}</p> : null}
            <label className="admin-users-field">
              <span>New password</span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <label className="admin-users-field">
              <span>Confirm password</span>
              <input
                type="password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </label>
            <div className="auth-actions">
              <button type="submit" className="midpoint-share-button">
                Update password
              </button>
              <Link to={paths.login}>Back to login</Link>
            </div>
          </form>
        )}
      </section>
    </div>
  );
};

export default ClientResetPasswordPage;
